<template>
  <div>
    <!--统计行-->
    <indexCard ></indexCard>
    <!--图表行-->
    <indexLineChart class="m-t-20"></indexLineChart>
    <!-- 门店分布饼图/销售排行/积分商城柱状图 -->
    <div class="m-t-10">
      <a-row :gutter="[20,20]" style="display: flex;flex-wrap: wrap;">
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="isShowPie ? 5 : 10">
          <supply ></supply>
        </a-col>
        <a-col v-if="isShowPie" :xs="24" :sm="24" :md="24" :lg="24" :xl="7">
          <store-pie :style="{minHeight: '500px'}"></store-pie>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="isShowPie ? 12 : 14">
          <sale-ranking :style="{minHeight: '500px'}"></sale-ranking>
        </a-col>
        <!-- <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="isShowPie ? 7 : 12">
          <points-mall style="minHeight: 467px"></points-mall>
        </a-col> -->
      </a-row>
    </div>
    <!-- 商品库存统计 -->
    <div class="m-t-24">
      <productStock></productStock>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import indexCard from './components/indexElement/card.vue'
import indexLineChart from './components/indexElement/lineChart.vue'
import supply from './components/indexElement/supply.vue'
import storePie from './components/indexElement/storePie.vue'
import saleRanking from './components/indexElement/saleRanking.vue'
// import pointsMall from './components/indexElement/pointsMall.vue'
import productStock from './components/indexElement/productStock.vue'
export default {
  components: {
    indexCard,
    indexLineChart,
    supply,
    storePie,
    saleRanking,
    // pointsMall,
    productStock
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['user']),
    isShowPie () {
      return this.user.adminRole !== 'staff' || (this.user.adminRole === 'staff' && this.user.level === '1')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
